import { ACTIVATE_OVERLAY, DEACTIVATE_OVERLAY } from "./types";

export const activateOverlayAction = (id, triggered = true) => ({
  type: ACTIVATE_OVERLAY,
  payload: { id, triggered }
});

export const deactivateOverlayAction = id => ({
  type: DEACTIVATE_OVERLAY,
  payload: id
});



// WEBPACK FOOTER //
// ./src/services/ui/overlay/actions.js